<template>
    <div class="ipsative-choice overflow-hidden">
        <question :text="$t(item.text)" />
        <div class="ipsative-choice__container mx-auto mt-4">
            <div class="ipsative-choice__choices-header d-flex mb-1 mb-lg-3">
                <div class="ipsative-choice__choice-header ipsative-choice__most" v-html="$t(item.text + '_MOST')">
                </div>
                <div class="ipsative-choice__choice-header ipsative-choice__least" v-html="$t(item.text + '_LEAST')">
                </div>
            </div>
            <div
                :key="`${key}-vs-choice-${i}`"
                class="d-flex ipsative-choice__section mb-2"
                v-for="(choice, i) in choices"
            >
                <vs-checkbox
                    :key="`${key}-vs-choice-${i}-box`"
                    class="ipsative-choice__checkbox"
                    @change="(value) => handleChange(value, i)"
                    :values="resultValues"
                    :choice="choice.name"
                    :selected="results[i] && results[i].result"
                />
                <div class="ipsative-choice__label d-flex align-items-center">
                    {{ $t(choice.text) }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import vsCheckbox from '@/components/inputs/vsCheckbox';
import question from '@/components/ui/question';
import { IPSATIVE_RESULTS } from '@/constants/items';

export default {
  name: 'ipsativeChoiceItem',
  components: {
    question,
    'vs-checkbox': vsCheckbox,
  },
  props: {
    item: {
      type: Object,
    },
  },
  data() {
    return {
      results: [],
      key: 1,
    };
  },
  computed: {
    choices() {
      return this.item.choices;
    },
    resultValues() {
      return [IPSATIVE_RESULTS.HIGHEST, IPSATIVE_RESULTS.LOWEST];
    },
    hasRequiredResults() {
      return this.results.find(r => r.result === IPSATIVE_RESULTS.HIGHEST) && this.results.find(r => r.result === IPSATIVE_RESULTS.LOWEST);
    },
  },
  methods: {
    handleChange(result, i) {
      const resultsCp = [...this.results];

      const index = resultsCp.findIndex(val => val.result === result.value);
      if (index !== -1) {
        // uncheck if we already have one same result
        resultsCp[index].result = IPSATIVE_RESULTS.NEUTRAL;
      }
      resultsCp[i].result = result.value;

      this.results = resultsCp;

      if (this.hasRequiredResults) {
        this.$emit('answer', this.results);
      } else {
        this.$emit('answer', null);
      }
    },
  },
  mounted() {
    this.results = this.item.choices.map(choice => ({
      choice: choice.result,
      result: IPSATIVE_RESULTS.NEUTRAL,
    }));
  },
};
</script>
<style lang="scss">
    .ipsative-choice__container{
        max-width: 420px;
    }

    .ipsative-choice__checkbox {
        margin-right: 0.5em;
    }

    .ipsative-choice__label {
        min-height: 55px;
        font-size: 0.95em;
        @media screen and (min-width: 992px) {
            font-size: 1em;
        }
    }

    .ipsative-choice__choice-header {
        font-size: 0.75em;
        font-weight: 600;
        margin-right: 8px;
        width: 80px;
        text-align: center;

        @media screen and (min-width: 992px) {
            font-size: 0.8em;
        }
    }

</style>
